import "./style.scss";
import Hazo from "../../Assets/img/hazo.png";

function Intermediary() {
  return (
    <div className="compNotFound">
      <div className="imgArea">
        <img src={Hazo} alt="avatar" />
      </div>
      <div className="opsArea">
        <h1>
          Ops! <br />
          Página não encontrada!
        </h1>
        <p>Parece que essa página não existe, o que você pode fazer:</p>
        <ul>
          <li>Verificar se o endereço está correto.</li>
          <li>Entrar em contato com quem te enviou o link.</li>
        </ul>
        <p>Se precisar de ajuda, é só nos avisar! 😉</p>
        <p>Fale conosco pelo e-mail hazo@hazo.app</p>
      </div>
    </div>
  );
}

export default Intermediary;
